// eslint-disable-next-line import/no-anonymous-default-export
export default {
	INDEX: "",

	PUBLIC: {
		LANDING: "/",
		PRICING: "/modern-pricing",
		MODERN_PRICING: "/modern-pricing",
		SIGNUP: "/signup",
		SIGNUP_SUCCESS: "/signup/success",
		PAYMENT: "/payment",
		PAYMENT_SUCCESS: "/payment-success",
		INVITE: "/invite",
		CLAIM: "/claim",
		SUPPLIER_REQUEST: "/supplier-request",
	},

	USER: {
		ACCOUNT: "/account",
		MEMBERSHIP: "/membership",
		CUSTOMER_PORTAL: "/billing",
		CHANGEPASSWORD: "/change-password",
		API_KEYS: "/api-keys",
		REPORT_BUG: "/report-bug",
	},
	MANAGEMENT: {
		FACILITIES: "/data/facility",
		CUSTOMFACTORS: "/data/custom-factors",
		SPENDBASED: "/data/spend-based",
		SCOPE3CATEGORIES: "/data/scope3-categories",
		SCOPE3ENTRIES: "/data/scope3-entries",
		EQUIPMENT: "/data/equipment",
		BUSINESSTRAVELS: "/data/business-travels",
		COMMUTING: "/data/commuting",
		ELECTRICITY: "/data/electricity",
		FUELCOMBUSTED: "/data/fuel-combusted",
		FUGITIVEGASES: "/data/fugitive-gases",
		FUGITIVEPROCESS: "/data/fugitive-processes",
		OTHEREMISSIONS: "/data/other-emissions",
		PROCESSESCALCINATION: "/data/processes-calcination",
		PROFIT: "/data/profit",
		TRANSPORTROAD: "/data/transport-road",
		TRANSPORTSEA: "/data/transport-sea",
		VEHICLE: "/data/vehicle",
		VEHICLEUSAGE: "/data/vehicle-usage",
		OTHEREMISSION: "/data/other-emissions",
	},
	USERCOMPANY: {
		DATA: {
			FILEUPLOAD: "/data/file-upload",
			FACILITIES: "/data/facility",
			FILELOG: "/data/file-log",
			BILLUPLOAD: "/data/bill-upload",
			BILLREVIEW: "/data/bill-review",
		},
		DASHBOARD: {
			INDEX: "/dashboard",
		},
		REPORT: {
			INDEX: "/reports",
			DATA_PACK: "/data-pack",
			BASELINES: "/baselines",
			S2REPORT: "/s2-report",
			NGER_REPORT: "/nger-report",
			DISCLOSURE_WORKSPACE: "/disclosure-workspace",
			CLIMATE_TARGETS: "/climate-targets",
			CLIMATE_RISKS: "/climate-risks",
			PORTFOLIO: "/portfolio",
			ASSURANCE: "/assurance",
			DATA_QUALITY: "/data-quality",
			SUPPLIER_REQUESTS: "/supplier-requests",
			GROUPS: "/groups",
		},
	},
	MACC: {
		ARTEHDECARBONIZATIONSTRATEGIES:
			"/macc/decarbonization-strategies/ArtehList",
		COMPANYDECARBONIZATIONSTRATEGIES:
			"/macc/decarbonization-strategies/CompanyList",
		SCENARIOSIMULATION:
			"/macc/decarbonization-strategies/ScenarioSimulation",
	},
};
